import { ITechStack } from "../components/pages/about-us/interfaces/ITechStack";

export default abstract class TechStackService {
    public static getFrontEndStack(): Array<ITechStack> {
        return [
            {
                imgSrc: "./javascript.png",
                description: "JavaScript"
            },
            {
                imgSrc: "./typescript.png",
                description: "TypeScript"
            },
            {
                imgSrc: "./react.png",
                description: "React"
            },
            {
                imgSrc: "./primereact.png",
                description: "Prime React"
            },
            {
                imgSrc: "./angular.png",
                description: "Angular"
            },
            {
                imgSrc: "./angular-material.svg",
                description: "Angular Material"
            },
            {
                imgSrc: "./aurelia.png",
                description: "Aurelia"
            },
            {
                imgSrc: "./jquery.png",
                description: "jQuery"
            },
            {
                imgSrc: "./html5.png",
                description: "HTML"
            },
            {
                imgSrc: "./css3.png",
                description: "CSS"
            },
            {
                imgSrc: "./sass.png",
                description: "SASS"
            },
            {
                imgSrc: "./less.png",
                description: "LESS"
            },
            {
                imgSrc: "./bootstrap.png",
                description: "Bootstrap"
            },
        ];
    }

    public static getBackEndStack(): Array<ITechStack> {
        return [
            {
                imgSrc: "./dotnet.png",
                description: ".NET"
            },
            {
                imgSrc: "./csharp.png",
                description: "C#"
            },
            {
                imgSrc: "./visualbasic.png",
                description: "Visual Basic"
            },
            {
                imgSrc: "./efcore.png",
                description: "Entity Framework Core"
            },
            {
                imgSrc: "./nodejs.png",
                description: "NodeJS"
            }
        ];
    }

    public static getDevOpsAndCloudStack(): Array<ITechStack> {
        return [
            {
                imgSrc: "./aws.png",
                description: "Amazon Web Services"
            },
            {
                imgSrc: "./azure.png",
                description: "Microsoft Azure"
            },
            {
                imgSrc: "./linux.png",
                description: "Linux"
            },
            {
                imgSrc: "./docker.png",
                description: "Docker"
            },
            {
                imgSrc: "./terraform.png",
                description: "Terraform"
            },
            {
                imgSrc: "./git.png",
                description: "Git"
            },
            {
                imgSrc: "./github.png",
                description: "GitHub"
            }
        ]
    }

    public static getDatabaseStack(): Array<ITechStack> {
        return [
            {
                imgSrc: "./sql.png",
                description: "SQL"
            },
            {
                imgSrc: "./mssql.png",
                description: "MS SQL Server"
            },
            {
                imgSrc: "./mysql.png",
                description: "MySQL"
            },
            {
                imgSrc: "./postgresql.png",
                description: "PostgreSQL"
            },
            {
                imgSrc: "./mariadb.png",
                description: "MariaDB"
            },
            {
                imgSrc: "./nosql.png",
                description: "NoSQL"
            },
            {
                imgSrc: "./mongodb.png",
                description: "MongoDB"
            },
            {
                imgSrc: "./cassandra.png",
                description: "Cassandra"
            },
        ]
    }
} 